import React, { useEffect, useState, useRef } from 'react';

const InstagramFeed = () => {
    const [posts] = useState([
        { id: '1', permalink: 'https://www.instagram.com/reel/DR108SuCsbv/', media_url: '/assets/images/learn/learn_image2.jpg' },
        { id: '2', permalink: 'https://www.instagram.com/reel/DRyiryhCCT7/', media_url: '/assets/images/learn/learn_image3.jpg' },
        { id: '3', permalink: 'https://www.instagram.com/reel/DQTqOvtkt3w/', media_url: '/assets/images/learn/learn_image4.jpg' },
        { id: '4', permalink: 'https://www.instagram.com/reel/DP6AB_PEqIr/', media_url: '/assets/images/learn/learn_image5.jpg' },
        { id: '5', permalink: 'https://www.instagram.com/reel/DPngQjLkkPL/', media_url: '/assets/images/learn/learn_image6.jpg' },
        { id: '6', permalink: 'https://www.instagram.com/reel/DPi0f_Oiq5b/', media_url: '/assets/images/learn/learn_image7.jpg' },
    ]);
    const [loaded, setLoaded] = useState(false);
    const sliderRef = useRef(null);

    const scrollLeft = () => {
        sliderRef.current.scrollBy({
            left: -sliderRef.current.offsetWidth,
            behavior: "smooth",
        });
    };

    const scrollRight = () => {
        sliderRef.current.scrollBy({
            left: sliderRef.current.offsetWidth,
            behavior: "smooth",
        });
    };


    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://www.instagram.com/embed.js';
        script.async = true;
        script.onload = () => {
            if (window.instgrm) {
                window.instgrm.Embeds.process();
            }
        };
        document.body.appendChild(script);
    }, []);

    return (
        <section className="reel-section mt-5 text-primary">
            <h1>Follow Us on Social Media</h1>
            <button className="slider-arrow left" onClick={scrollLeft}>
                <i className="fas fa-chevron-left"></i>
            </button>
            <div className="instagram-grid" ref={sliderRef}>
                {posts.map((post, index) => (
                    <div key={post.id || index} className="instagram-embed-wrapper">
                        <blockquote
                            className="instagram-media"
                            data-instgrm-permalink={post.permalink}
                            data-instgrm-version="14"
                        />
                    </div>
                ))}
            </div>
            <button className="slider-arrow right" onClick={scrollRight}>
                <i className="fas fa-chevron-right"></i>
            </button>
        </section>
    );
};

export default InstagramFeed;



//import React, { useEffect, useState } from 'react';

//const InstagramFeed = () => {
//    const [posts, setPosts] = useState([]);
//    const [loading, setLoading] = useState(true);
//    const [error, setError] = useState(null);
//    const [loaded, setLoaded] = useState(false);

//    useEffect(() => {
//        fetchLatestPosts();
//    }, []);

//    useEffect(() => {
//        if (posts.length > 0 && !loaded) {
//            const script = document.createElement('script');
//            script.src = 'https://www.instagram.com/embed.js';
//            script.async = true;
//            script.onload = () => {
//                if (window.instgrm) {
//                    window.instgrm.Embeds.process();
//                    setLoaded(true);
//                }
//            };
//            document.body.appendChild(script);

//            return () => {
//                document.body.removeChild(script);
//            };
//        }
//    }, [posts, loaded]);

//    const fetchLatestPosts = async () => {
//        try {
//            setLoading(true);
//            const response = await fetch('http://localhost:7093/api/instagram/posts');

//            if (!response.ok) {
//                throw new Error(`API error: ${response.status}`);
//            }

//            const data = await response.json();
//            setPosts(data);
//        } catch (err) {
//            console.error('Error fetching Instagram posts:', err);
//            setError('Unable to load Instagram feed');
//            setPosts(getFallbackPosts());
//        } finally {
//            setLoading(false);
//        }
//    };

//    const getFallbackPosts = () => {
//        return [
//            { id: '1', permalink: 'https://www.instagram.com/reel/DR108SuCsbv/', media_url: '/assets/images/learn/learn_image2.jpg' },
//            { id: '2', permalink: 'https://www.instagram.com/reel/DRyiryhCCT7/', media_url: '/assets/images/learn/learn_image3.jpg' },
//            { id: '3', permalink: 'https://www.instagram.com/reel/DQTqOvtkt3w/', media_url: '/assets/images/learn/learn_image4.jpg' },
//            { id: '4', permalink: 'https://www.instagram.com/reel/DP6AB_PEqIr/', media_url: '/assets/images/learn/learn_image5.jpg' },
//            { id: '5', permalink: 'https://www.instagram.com/reel/DPngQjLkkPL/', media_url: '/assets/images/learn/learn_image6.jpg' },
//            { id: '6', permalink: 'https://www.instagram.com/reel/DPi0f_Oiq5b/', media_url: '/assets/images/learn/learn_image7.jpg' },
//        ];
//    };

//    if (loading) {
//        return (
//            <section className="reel-section mt-5 text-primary">
//                <div className="container">
//                    <h2 className="section-title">Instagram Feed</h2>
//                    <div className="loading-grid">
//                        {[...Array(9)].map((_, index) => (
//                            <div key={index} className="loading-card"></div>
//                        ))}
//                    </div>
//                </div>
//            </section>
//        );
//    }

//    if (error && posts.length === 0) {
//        return (
//            <section className="reel-section mt-5 text-primary">
//                <div className="container">
//                    <h2 className="section-title">Instagram Feed</h2>
//                    <div className="error-message">{error}</div>
//                </div>
//            </section>
//        );
//    }

//    return (
//        <section className="reel-section mt-5 text-primary">
//            <h1>Follow Us on Social Media</h1>

//                <div className="instagram-grid">
//                    {posts.map((post, index) => (
//                        <div key={post.id || index} className="instagram-embed-wrapper">
//                            <blockquote
//                                className="instagram-media"
//                                data-instgrm-permalink={post.permalink}
//                                data-instgrm-version="14"
//                                style={{
//                                    background: '#FFF',
//                                    border: '0',
//                                    borderRadius: '12px',
//                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
//                                    margin: '1px',
//                                    width: '100%',
//                                }}
//                            />
//                        </div>
//                    ))}
//                </div>
//        </section>
//    );
//};

//export default InstagramFeed;



//import React, { useEffect, useState } from "react";
//import { Container, Row, Col, Modal, ModalBody } from "reactstrap";
////import "./instaFeed.css";

//const INSTAGRAM_FEED = [
//    { url: "https://www.instagram.com/reel/DR108SuCsbv/", thumb: "/assets/images/noImage/no-image5.png" },
//    { url: "https://www.instagram.com/reel/DRyiryhCCT7/", thumb: "/assets/images/noImage/no-image5.png" },
//    { url: "https://www.instagram.com/reel/DQTqOvtkt3w/", thumb: "/assets/images/noImage/no-image5.png" },
//    { url: "https://www.instagram.com/reel/DP6AB_PEqIr/", thumb: "/assets/images/noImage/no-image5.png" },
//    { url: "https://www.instagram.com/reel/DPngQjLkkPL/", thumb: "/assets/images/noImage/no-image5.png" },
//    { url: "https://www.instagram.com/reel/DPi0f_Oiq5b/", thumb: "/assets/images/noImage/no-image5.png" },
//];

//export default function InstaFeed() {
//    const [activeIndex, setActiveIndex] = useState(null);

//    useEffect(() => {
//        if (activeIndex !== null) {
//            setTimeout(() => {
//                window.instgrm?.Embeds?.process();
//            }, 400);
//        }
//    }, [activeIndex]);

//    return (
//        <section className="py-5 bg-white">
//            <Container>
//                <h2 className="text-center mb-4 fw-semibold text-primary">
//                    Trusted By Our Insta Community
//                </h2>

//                <Row className="g-3">
//                    {INSTAGRAM_FEED.map((item, index) => (
//                        <Col xs="6" md="4" lg="3" key={index}>
//                            <div
//                                className="insta-thumb"
//                                onClick={() =>
//                                    window.open(INSTAGRAM_FEED[index].url, "_blank")
//                                }
//                            >
//                                <img src={item.thumb} alt="Instagram post" />
//                                <div className="insta-overlay">View</div>
//                            </div>
//                        </Col>
//                    ))}
//                </Row>

                //{/*<div className="refresh-section">*/}
                //{/*    <button*/}
                //{/*        onClick={fetchLatestPosts}*/}
                //{/*        className="refresh-button"*/}
                //{/*        disabled={loading}*/}
                //{/*    >*/}
                //{/*        {loading ? 'Loading...' : 'Load New Posts'}*/}
                //{/*    </button>*/}
                //{/*    <p className="update-note">Automatically updates with your latest posts</p>*/}
                //{/*</div>*/}

//                <Modal
//                    isOpen={activeIndex !== null}
//                    toggle={() => setActiveIndex(null)}
//                    size="lg"
//                    centered
//                    backdrop="static"
//                >
//                    <ModalBody className="insta-modal-body">
//                        <div className="insta-loader">Loading Instagram…</div>

//                        {activeIndex !== null && (
//                            <blockquote
//                                className="instagram-media"
//                                data-instgrm-permalink={INSTAGRAM_FEED[activeIndex].url}
//                                data-instgrm-version="14"
//                            ></blockquote>
//                        )}
//                    </ModalBody>
//                </Modal>
//            </Container>
//        </section>
//    );
//}
